/**
 * @module components/Form/FormGroupManualCoordinates
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Field for getting manual coordinates
 */

import { useState, useEffect } from 'react';

import { Col, ControlLabel, FormGroup, FormControl, Button } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';

import { useAppState } from '../../contexts/app-state-provider';


type Props = {
  values: FormCoordinates,
  onCoordinates: FormOnCoordinates,
}


/**
 * React component
 * ===============
 */
const FormGroupManualCoordinates = ({
  values,
  onCoordinates,
}: Props) => {
  const [ lang ] = useLanguageState();
  const [ state ] = useAppState();
  const [ latitude, setLatitude ] = useState<string|number|undefined>(values[0]);
  const [ longitude, setLongitude ] = useState<string|number|undefined>(values[1]);

  // Change the state if the component updated
  useEffect(() => {
    setLatitude(values[0]);
    setLongitude(values[1]);
  }, [values]);

  let enabled = false
  if( latitude && longitude ) {
    enabled = (
      Number(latitude) >= state.form.latitudeLimits[0]
      && Number(latitude) <= state.form.latitudeLimits[1]
      && Number(longitude) >= state.form.longitudeLimits[0]
      && Number(longitude) <= state.form.longitudeLimits[1]
    )
  }

  const dlat = (latitude === undefined)?'':latitude;
  const dlon = (longitude === undefined)?'':longitude;

  return (
    <>
      <p>{lang.form.coodinatesManualInstructions}</p>
      <FormGroup controlId="latitude">
        <Col componentClass={ControlLabel} sm={2}>
          Latitude
        </Col>
        <Col sm={10}>
          <FormControl
            type="number"
            step="any"
            min={state.form.latitudeLimits[0]}
            max={state.form.latitudeLimits[1]}
            value={dlat}
            onChange={(e) => setLatitude(Number((e.target as HTMLButtonElement).value))}
          />
          <FormControl.Feedback />
        </Col>
      </FormGroup>
      <FormGroup controlId="longitude">
        <Col componentClass={ControlLabel} sm={2}>
          Longitude
        </Col>
        <Col sm={10}>
          <FormControl
            type="number"
            step="any"
            min={state.form.longitudeLimits[0]}
            max={state.form.longitudeLimits[1]}
            value={dlon}
            onChange={(e) => setLongitude(Number((e.target as HTMLButtonElement).value))}
          />
          <FormControl.Feedback />
        </Col>
      </FormGroup>
      <Col smOffset={2}>
        <Button
          onClick={() => {
            onCoordinates(Number(latitude), Number(longitude))
          }}
          disabled={!enabled}
        >
          {lang.form.setCoordinates}
        </Button>
      </Col>
    </>
  );
}


export default FormGroupManualCoordinates;
